// extracted by mini-css-extract-plugin
export default {"separation":"styles-module__separation__src-labstep-web-core-List-_Sql5K","doubleSpaced":"styles-module__doubleSpaced__src-labstep-web-core-List-_ZTsn3"};